export default __webpack_public_path__ + "static/Futura-Bold-f9486ea9dfd58097f383e4704ed90252.woff2";